// Best-effort extraction of "how many results have completed so far" from either
// a WS message payload or a polling REST response. Multi-result flows rely on
// this to distinguish partial-batch status:1 signals from true completion.
// Returns null when the payload shape is unknown — in that case the caller
// falls back to the internal per-result dedup counter (see terminalCountRef).
export const getCompletedCount = (payload: any): number | null => {
  if (!payload) return null;
  if (typeof payload.image_count === "number") return payload.image_count;
  if (Array.isArray(payload.images)) return payload.images.length;
  if (typeof payload.design_detail?.image_count === "number") return payload.design_detail.image_count;
  if (Array.isArray(payload.design_detail?.images)) return payload.design_detail.images.length;
  if (Array.isArray(payload.data)) return payload.data.length;

  return null;
};

// Extracts a stable per-result dedup key so we can count terminal matches for
// flows where the payload doesn't carry a cumulative count (e.g. Studio sends
// one WS message per pose, each with a unique image_url).
export const getResultKey = (payload: any): string | null => {
  if (!payload) return null;
  if (typeof payload.image_url === "string") return payload.image_url;
  if (typeof payload?.data?.image_url === "string") return payload.data.image_url;
  if (Array.isArray(payload?.data) && typeof payload.data[0]?.id === "string") return payload.data[0].id;

  return null;
};
